import React, { memo } from 'react';
import styled from 'styled-components';
import { Box, Grid, theme } from 'pcln-design-system';
import { format } from 'date-fns/format';
import Day from '../Day/Day';
import DayNames from '../DayNames/DayNames';
import MonthName from '../MonthName/MonthName';
import { DayMapContext } from '../DayMapProvider';
import { PRICELINE_DATE_FORMAT } from '../constants/dates';
const now = format(Date.now(), PRICELINE_DATE_FORMAT);
const MonthBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Month__MonthBox",
  componentId: "sc-1chorlj-0"
})(["&&&{", "{", "}}"], props => props.theme ? props.theme.mediaQueries.md : theme.mediaQueries.md, props => !props.isMobile && `
        vertical-align: top;
        display: inline-block;
      `);
function Month({
  dayGap = '4px 0',
  days,
  dayWithRoundedCorners,
  dayWrapperStyleOverride,
  didUseKeyNavigation,
  displayYear,
  endDate,
  highlightedDates,
  hoveredDate,
  isMobile,
  isTouch,
  labels,
  locale,
  maxDate = now,
  maxSelectableDate,
  minDate = now,
  monthIndex,
  monthWidth = 380,
  showHoveredDates,
  startDate,
  use2024DesignSeti,
  year,
  getCalendarLegendId,
  onDayClicked,
  onDayHovered,
  setSelectedDayRef
}) {
  return React.createElement(MonthBox, {
    isMobile: isMobile,
    p: 3,
    my: 0,
    width: isMobile ? 1 : [1, null, monthWidth]
  }, React.createElement(MonthName, {
    displayYear: displayYear,
    locale: locale,
    monthIndex: monthIndex,
    use2024DesignSeti: use2024DesignSeti,
    year: year
  }), React.createElement(DayNames, {
    locale: locale
  }), React.createElement(DayMapContext.Consumer, null, priceContext => React.createElement(Grid, {
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: dayGap
  }, days.map((fullDate, i) => React.createElement(Day, {
    ariaLabel: labels && labels[i] || '',
    customDayProps: priceContext && priceContext.dayMap ? priceContext.dayMap[fullDate] : null,
    dayWrapperStyleOverride: dayWrapperStyleOverride,
    dayWithRoundedCorners: dayWithRoundedCorners,
    didUseKeyNavigation: didUseKeyNavigation,
    endDate: endDate,
    fullDate: fullDate,
    highlightedDates: highlightedDates,
    hoveredDate: hoveredDate,
    isTouch: isTouch,
    key: `datepicker-day-${fullDate || `${monthIndex}${i}`}`,
    locale: locale,
    maxDate: maxDate,
    maxSelectableDate: maxSelectableDate,
    minDate: minDate,
    renderDayFn: priceContext && priceContext.renderDayFn,
    showHoveredDates: showHoveredDates,
    startDate: startDate,
    use2024DesignSeti: use2024DesignSeti,
    onDayClicked: onDayClicked,
    onDayHovered: onDayHovered,
    getCalendarLegendId: getCalendarLegendId,
    setSelectedDayRef: setSelectedDayRef
  })))));
}
export function areEqual(prevProps, nextProps) {
  const {
    currentMonthIndex,
    index,
    monthsToShow
  } = nextProps;
  const isPastMonth = index < currentMonthIndex;
  const isFutureMonth = index > currentMonthIndex + monthsToShow;
  if (isPastMonth || isFutureMonth) {
    return true;
  }
  return prevProps === nextProps;
}
export default memo(Month, areEqual);